import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import { userGroupUrl } from '@/constants/urls';
import RowDeleteButton from '@/components/buttons/RowDeleteButton';
import { states } from '@/constants/lifecycle';
import NameDescriptionRow from '@/components/table/NameDescriptionRow';
import { columnDescription, columnName, columnNameLink } from '@/constants/fields';

const UsersGroupRow = ({
  allowRead,
  allowRemove,
  category,
  className,
  lastItem,
  removeGroup,
  user,
  userGroup,
}) => (
  <NameDescriptionRow
    className={clsx('aridhia-users-groups-row', className)}
    columns={[allowRead ? columnNameLink : columnName, columnDescription]}
    description={userGroup.description}
    entity="usergroup"
    href={allowRead ? userGroupUrl(userGroup) : undefined}
    name={userGroup.name}
  >
    {allowRemove && (
      <Table.Cell collapsing>
        <RowDeleteButton
          entity="user.group"
          disabled={userGroup.destroyStatus === states.PENDING}
          floated="right"
          onClick={() => removeGroup(category, user, userGroup)}
          dataPosition={lastItem ? 'top right' : undefined}
        />
      </Table.Cell>
    )}
  </NameDescriptionRow>
);

export default UsersGroupRow;
